import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';

import { ButtonMenuOption } from './models/button-menu-option';

@Component({
    selector: 'app-button-menu',
    standalone: true,
    imports: [MatButtonModule, MatMenuModule, MatIconModule],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './button-menu.component.html',
})
export class ButtonMenuComponent {
    @Input() title: string = '';
    @Input() classList: string = '';
    @Input() options: ButtonMenuOption[] = [];
}
